"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const CustomCheckmarkIcon = () => (react_1.default.createElement("svg", { width: "11", height: "11", viewBox: "0 0 11 11", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    react_1.default.createElement("g", { id: "Check line" },
        react_1.default.createElement("path", { id: "Line 1", d: "M1.36312 6.49928L4.11997 9.62085L9.92708 2.54203", stroke: "white", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }))));
exports.default = CustomCheckmarkIcon;
//# sourceMappingURL=CustomCheckmarkIcon.js.map